import React from 'react';
import PropTypes from 'prop-types';

import styles from './FixedRight.module.scss';

const FixedRight = ({bg, children}) => (
  <div className={styles.container + (bg ? ` ${styles[bg]}` : '')}>
    <div className={styles.wrap}>
      {children}
    </div>
  </div>
);

FixedRight.propTypes = {
  bg: PropTypes.string,
  children: PropTypes.node,
};

export default FixedRight;
